import {Component, Input, ViewEncapsulation} from '@angular/core';
import {SipHeader} from '../../../../services/enums/sip-header.enum';

@Component({
  selector: 'rule-action-box',
  templateUrl: './rule-action-box.component.html',
  styleUrls: ['./rule-action-box.component.scss']
})
export class RuleActionBoxComponent {

  @Input() item: any;

  constructor() {
  }

  isDiscard(value): boolean {
    return value && value.discard;
  }

  doesCommaRequired(value): any {
    return (value.pConnection || value.node || value.voipPeer || value.resourceGroup) && (value.srcNormGroup || value.dstNormGroup);
  }

  getSrcNormHeaders(action): any {
    const headers = [];

    if (action.srcNormalizationFromHeader) {
      headers.push(SipHeader.FROM);
    }
    if (action.srcNormalizationPAIHeader) {
      headers.push(SipHeader.PAI);
    }
    if (action.srcNormalizationPPIHeader) {
      headers.push(SipHeader.PPI);
    }

    if (headers.length > 0) {
      return `( ${headers.join(', ')} )`;
    }

    return '';
  }

}
